import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO, { BreadcrumbSchema } from "../components/SEO";
import { BRAND, CONTACT } from "../lib/content";

export default function Terms() {
  return (
    <>
      <SEO title="Terms of Use" description={`Terms of use for the ${BRAND.name} website.`} path="/terms" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://bcpeabody.com/" }, { name: "Terms of Use", url: "https://bcpeabody.com/terms" }]} />
      <Nav />

      <section className="pt-32 pb-10 bg-cream-light">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.18em] uppercase mb-5 text-copper">Legal</div>
          <h1 className="font-serif font-medium text-ink tracking-tight leading-[1.05]" style={{ fontSize: "clamp(34px, 5vw, 56px)" }}>
            Terms of Use
          </h1>
          <p className="mt-6 text-ink/70 text-sm">Effective date: October 2026</p>
        </div>
      </section>

      <section className="bg-cream-light pb-24">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 space-y-5 text-ink/85 leading-relaxed" style={{ fontSize: 16 }}>
          <p>By using bcpeabody.com you agree to these terms.</p>

          <p><strong>Information only.</strong> Content on this site is general information about BCPeabody and our services. It is not an offer, a contract, or engineering, legal or professional advice for your situation. Project scope, pricing and schedule are set only in a signed written agreement.</p>

          <p><strong>Licensing.</strong> {BRAND.legalName} is a Florida Certified General Contractor, CGC1515086.</p>

          <p><strong>Project information.</strong> Project descriptions, values and dates are summaries for illustration. Photos show past work and may not represent every project.</p>

          <p><strong>Ownership.</strong> Text, photos, logos and design on this site belong to BCPeabody or are used with permission. Please don't copy or reuse them without written permission.</p>

          <p><strong>Links.</strong> Links to other websites are for convenience. We are not responsible for their content.</p>

          <p><strong>No warranty.</strong> The site is provided "as is." We work to keep it accurate but don't guarantee that it is complete, current or error-free.</p>

          <p><strong>Limitation of liability.</strong> To the extent allowed by law, BCPeabody is not liable for damages arising from use of this website.</p>

          <p><strong>Governing law.</strong> These terms are governed by the laws of the State of Florida.</p>

          <p><strong>Contact.</strong> <a href={`mailto:${CONTACT.email}`} className="text-copper">{CONTACT.email}</a> · <a href={CONTACT.phoneHref} className="text-copper">{CONTACT.phone}</a></p>
        </div>
      </section>
      <Footer />
    </>
  );
}
